var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 22"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.5","d":"M.8.8h26.5M.8 10.8h20.5M.8 20.8h14.5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }